export function convertKeysToUppercase(obj: Record<string, string>): Record<string, string> {
  const newObj: Record<string, string> = {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const uppercaseKey = key.toUpperCase();
      newObj[uppercaseKey] = obj[key];
    }
  }

  return newObj;
}
